import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogConfirmation from "@/pages/PartsCatalogConfirmation";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/checkout/confirmation/$orderNumber")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/parts-catalog/checkout/confirmation/:orderNumber' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: PartsCatalogConfirmation,
});
